// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".the-personal-orders__select{margin-bottom:10px}@media only screen and (min-width:992px){.the-personal-orders__select{max-width:240px;margin-bottom:15px}}", ""]);
// Exports
module.exports = exports;
